import React from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Img from 'gatsby-image/withIEPolyfill'
import { getFluidGatsbyImage } from '../hooks/getFluidGatsbyImage'

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: node => {
      const { file, title } = node.data.target.fields
      const image = {
        file: file['de-AT'],
      }
      const fluidProps = getFluidGatsbyImage(image, { maxWidth: 1070 })
      return <Img fluid={fluidProps} alt={title['de-AT']} />
    },
  },
}

export default ({ richTextJson }) =>
  documentToReactComponents(richTextJson, options)
